var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 40,
    height: 40,
    rx: 6,
    fill: "#EAEFFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_436_9825)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 14.5C21.6569 14.5 23 13.1569 23 11.5C23 9.84315 21.6569 8.5 20 8.5C18.3431 8.5 17 9.84315 17 11.5C17 13.1569 18.3431 14.5 20 14.5Z",
    fill: "#0236C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9192 23.106L25.4392 17.318C24.9662 16.215 23.8822 15.5 22.6822 15.5H17.3202C16.1202 15.5 15.0352 16.215 14.5632 17.318L12.0832 23.106C11.8652 23.614 12.1012 24.202 12.6082 24.419C13.1152 24.636 13.7042 24.401 13.9212 23.894L16.0022 19.038V31.5C16.0022 32.052 16.4502 32.5 17.0022 32.5C17.5542 32.5 18.0022 32.052 18.0022 31.5V25.5H22.0022V31.5C22.0022 32.052 22.4502 32.5 23.0022 32.5C23.5542 32.5 24.0022 32.052 24.0022 31.5V19.038L26.0832 23.894C26.2452 24.273 26.6142 24.5 27.0022 24.5C27.1332 24.5 27.2672 24.474 27.3962 24.418C27.9032 24.201 28.1392 23.613 27.9212 23.105L27.9192 23.106Z",
    fill: "#0236C7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_436_9825"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon-1.beeb2402e24bbb81e150a3fbcde8d2c8.svg";
export { ForwardRef as ReactComponent };